import { useState } from 'react'
import {
  Datagrid,
  TextField,
  Show,
  SimpleShowLayout,
  ReferenceManyField,
  ImageField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  subtitle: {
    color: '#143A5F',
  },
  resolution_libelle: {
    color: '#143A5F',
  },
  typography: {
    fontFamily: 'Helvetica',
  },
})

const Title5 = (props) => {
  const { basePath, variant, ...rest } = props
  const classes = useStyles()
  return (
    <div>
      <br />
      <br />
      <Typography variant="h5" {...rest}>
        Feuille de présence
      </Typography>
    </div>
  )
}

export const PvAgFeuillePresence = (props) => {
  const classes = useStyles()

  const [open_resolution_id, setOr] = useState(null)
  const [not_ready, setR] = useState(false)

  return (
    <div>
      <Show {...props}>
        <SimpleShowLayout>
          <Title5 />
          <ReferenceManyField
            label=" "
            reference="agregistrations"
            target="ag_id"
            filter={{ source: 'feuillepresence' }}
          >
            <Datagrid>
              <TextField label="Nom" source="libelle" />
              <TextField label="Lots" source="lots" />
              <TextField label="Contact" source="contact" />
              <TextField label="Représenté par" source="representant" />
              <ImageField label="Signature" source="signature" />
            </Datagrid>
          </ReferenceManyField>
        </SimpleShowLayout>
      </Show>
    </div>
  )
}
